import { React, RouteComponentProps, i18n, inject, observer, pr, ui } from "aaa";
import { MessageScreen } from "components/common/MessageScreen";
import { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";

interface IProps {
    externalInterfaceStore: ExternalInterfaceStore;
}

@inject("externalInterfaceStore")
@observer
export class IchAppDeregistrationSuccess extends React.Component<IProps & i18n.InjectedIntlProps & RouteComponentProps<{}>, {}> {
    render() {
        return (
            <MessageScreen
                icon={pr.IconMessageOk}
                useWebVersion
                variant="success"
                message={ui.__("ichApp.deregistration.success.message")}
                buttonLabelId="common.backToGeorgeGo"
                onDismiss={() => this.props.externalInterfaceStore.raiseExitSuccess()}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ichApp/IchAppDeregistrationSuccess.tsx